<template>
  <el-container class="myContainer">
    <el-aside width="350px" class="myContainer">
      <el-card class="box-card">
        <el-tree :data="productCatalogData" :props="defaultProps" node-key="id"
                 @node-click="nodeClickHandle"
                 default-expand-all highlight-current ref="active"
                 :expand-on-click-node="false">

          <template #default="{ node, data }">
            <el-row style="width:99%" :gutter="20">
              <el-col :span="16" style="line-height: 32px">{{ node.label }}</el-col>

              <el-col :span="2" justify="end" v-show="currentProductCatalog.id == data.id" style="line-height: 32px;vertical-align: middle">
                <FrameButton v-if="data.level < 7" :key="data.id" :button="addButton" :parentData="data" ></FrameButton>
              </el-col>
              <el-col :span="2" justify="end" v-show="currentProductCatalog.id == data.id" style="line-height: 32px;vertical-align: middle">
                <FrameButton :key="data.id" :button="editButton" :parentData="data" ></FrameButton>
              </el-col>
              <el-col :span="2" justify="end" v-show="currentProductCatalog.id == data.id" style="line-height: 32px;vertical-align: middle">
                <FrameButton v-if="data.level == 0" :key="data.id" :button="impButton" ></FrameButton>
              </el-col>

            </el-row>
          </template>

        </el-tree>

      </el-card>

    </el-aside>

    <el-main class="myContainer">

      <el-card class="box-card">
        <template #header>
          <div class="card-header">
            <span width="100%" class="department-name">产品目录：{{ currentProductCatalog.name }}</span>
          </div>
        </template>
        <div>
          <frame-query ref="frameQuery" componentParam="crm_product" :parent-data="{catalog_id:currentProductCatalog.id}"></frame-query>
        </div>
      </el-card>

    </el-main>

  </el-container>
</template>

<script>
import {Refresh} from '@element-plus/icons-vue'
export default {
  name: "ProductCatalog",
  components: {Refresh},
  data() {
    return {
      addButton:{
        "component": "button",
        "text":true,
        "circle": true,
        "icon_only": true,
        "icon": "el-icon-CirclePlus",
        "click": "jsOpenDialog",
        "window": {"component": "frame/FrameForm", "type": "crm_product_catalog_add","title":"添加目录","width":800,"height":600}
      },
      editButton:{
        "component": "button",
        "text":true,
        "circle": true,
        "icon_only": true,
        "icon": "el-icon-Edit",
        "click": "jsOpenDialog",
        "window": {"component": "frame/FrameForm", "type": "crm_product_catalog_edit","title":"编辑目录","width":800,"height":600}
      },
      impButton:{
        "component": "button",
        "text":true,
        "circle": true,
        "icon_only": true,
        "icon": "el-icon-Grid",
        "click": "jsOpenDialog",
        "window": {"component": "frame/FrameForm", "type": "crm_product_catalog_import","title":"导入目录","width":800,"height":600}
      },
      addData: {parentId: '', name: ''},
      // departmentData: [],
      productCatalogData: [],
      // userData: [],
      productData: [],
      // currentDepartment: {},
      currentProductCatalog: {},
      // subPage: 'user',
      subPage: 'product',
      editData: {id: '', oldName: '', name: '',},
      defaultProps: {
        children: 'children',
        label: 'name',
      }
    }
  },
  methods: {
    //--勾选--
    //操作方式
    nodeClickHandle(currentRow) {
      this.currentProductCatalog = currentRow;
      this.$refs.frameQuery.search();
    },
    //获取数据信息
    async loadDirTree() {
      this.productCatalogData = await this.$http('crmProductCatalogService.getRootTree')
    },
    async getProductData() {
      let {data: res} = await this.$axios.get('purchase/getProductData');
      if (res.code !== 0) {
        this.$message.error('获取产品失败')
        return;
      }

      this.productData = res.data;
    }
  },
  provide(){
    return {
      $fn: {
        reLoadDirTree: () => {
          this.loadDirTree();
        },
      }
    }
  },
  created() {
    this.loadDirTree();
    this.getProductData()
  }
}
</script>

<style lang="less" scoped>
@import 'src/global';

.myContainer {
  padding: 5px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.department-name {
  font-size: @fontSizeXX;
}

.activeButton {
  background-color: #409EFF;
  color: #FFFFFF
}

.scroller::-webkit-scrollbar {
  width: 3px;
}

.scroller::-webkit-scrollbar-track {
  background-color: transparent;
}

.scroller::-webkit-scrollbar-thumb {
  background-color: #C1C1C1;
}

.departmentBody {
  border: #ececec solid 1px;
  font-weight: normal;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  height: 100%;
  width: 100%;
  padding: 0 1px 2px;
}

.departmentLeft {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 300px;
  box-sizing: content-box;
}

.departmentRight {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow: auto;
  width: 100%;
  min-width: 550px;
}

.treeIcon {
  margin-right: 10px
}

.LeftBody {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 300px;
  padding-top: 10px;
  overflow-y: auto;
}

.flexRow {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.userRights {
  display: flex;
  flex-direction: column;
  height: 100%;
  margin: 5px 5px 0 5px;
}

.departmentUserList {
  padding: 0 20px 10px;
  display: flex;
  flex-direction: column;
}

.departmentTitle {
  height: 45px !important;
  line-height: 40px;
  font-size: @fontSizeSS;
}

.departmentName {
  white-space: nowrap;
  min-width: 120px;
  margin-right: 30px;
  padding-right: 20px;
  font-size: @fontSizeS;
}

.titleFlex {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
}

.departmentEdit {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin: 10px 0;
}

.departmentTable {
  border: none;
  width: 100%;
}

.flexRow > .el-menu-item {
  height: 50px;
  line-height: 50px;
}

.buttonGroup {
  margin-left: auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.addButton {
  margin-left: 5px !important;
  padding: 9px;
}

.addDepartment {
  width: 140px;
  margin-right: 5px;
}

.LeftBody ::v-deep(.el-tree-node__expand-icon) {
  width: 15px;
}

.buttonGroup ::v-deep(.el-icon-key) {
  transform: rotate(180deg);
}

.editButton {
  color: lightgrey;
  min-height: 30px;
  padding: 0;
}

.editButton:hover {
  color: #00afff;
}
</style>
<style lang="less">
@import '@/global';

.rightTree > .el-tree-node > .el-tree-node__children {
  display: flex;
  flex-direction: row !important;
}

.rightTree > .el-tree-node > .el-tree-node__content {
  height: 40px;
}

.rightTree > .el-tree-node > .el-tree-node__content > .el-tree-node__label {
  font-size: @fontSizeS;
}

.departmentPoper {
  padding: 0 !important;
}

.poperItem {
  color: #409EFF;
  padding: 0 10px;
  height: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

.poperItem:hover {
  background: whitesmoke;
}

.textDepartment {
  font-size: medium;
}
</style>

<style scoped>
.el-tree >>> .el-tree-node__content {
  height: 36px;
}

.department-tree{
  min-height: 600px;
  max-height: 800px;
  overflow-y: auto;
}
</style>